import { render, staticRenderFns } from "./imageBox.vue?vue&type=template&id=724bb4fe&scoped=true"
import script from "./imageBox.vue?vue&type=script&lang=js"
export * from "./imageBox.vue?vue&type=script&lang=js"
import style0 from "./imageBox.vue?vue&type=style&index=0&id=724bb4fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724bb4fe",
  null
  
)

export default component.exports